<template>
  <div class="social-login">
    <v-btn
      @click="handleGoogleLogin"
      block
      size="large"
      variant="outlined"
      class="mb-3"
      prepend-icon="mdi-google"
      color="white"
    >
      <span class="text-white">Google로 계속하기</span>
    </v-btn>

    <v-btn
      @click="handleKakaoLogin"
      block
      size="large"
      variant="elevated"
      class="mb-3"
      prepend-icon="mdi-chat"
      style="background-color: #FEE500; color: #000000"
    >
      Kakao로 계속하기
    </v-btn>

    <v-btn
      @click="handleNaverLogin"
      block
      size="large"
      variant="elevated"
      class="mb-3"
      prepend-icon="mdi-alpha-n"
      style="background-color: #03C75A; color: #FFFFFF"
    >
      Naver로 계속하기
    </v-btn>
  </div>
</template>

<script setup>
const emit = defineEmits(['success'])

const handleGoogleLogin = () => {
  // Google 로그인 구현 예정
  console.log('Google 로그인 클릭')
  // 임시로 성공 이벤트 발생
  setTimeout(() => {
    emit('success')
  }, 500)
}

const handleKakaoLogin = () => {
  console.log('Kakao 로그인 클릭')
  alert('Kakao 로그인은 준비 중입니다.')
}

const handleNaverLogin = () => {
  console.log('Naver 로그인 클릭')
  alert('Naver 로그인은 준비 중입니다.')
}
</script>

<style scoped>
.social-login {
  width: 100%;
}

.v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
